/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/label-has-associated-control */
import { useDispatch, useSelector } from 'react-redux';
import { NavLink } from '@hydrogen/elements.core.router';
import { useLanguage } from '@hydrogen/elements.core.i18n';
import { useNavigate } from 'react-router-dom';
import { Button, Preloader } from '@dekafvv/sharedfrontend';
import { getCookie } from 'utils/storage';
import { logout } from 'utils/jwtToken';
import { resetUser } from 'redux/auth/authActions';
import {
    isAuthenticatedSelector,
} from 'redux/auth/authSelectors';
import { mutationLogout } from 'shared/Api/model/auth/queries';
import DekaLogo from './DekaLogo';
import styles from './Header.module.css';

declare global {
    interface Window {
        OSPlusNeo: {
            reportError: () => void;
        }
    }
}

export declare type NavLinkType = {
    label: string;
    link: string;
};

type HeaderProps = {
    navigations: NavLinkType[],
}

export const Header = ({ navigations = [] }: HeaderProps) => {
    const { t } = useLanguage();
    const isAuthenticated = useSelector(isAuthenticatedSelector);
    const contactId: number = parseInt(getCookie('client_id'), 10);
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const activeNavigation = isAuthenticated ? navigations : [];

    const {
        mutateAsync: mutateLogout,
        isLoading,
    } = mutationLogout({
        onSuccess: () => {
            logout(navigate);
            dispatch(resetUser());
        },
    });

    const logOut = {
        label: t('common.logout'),
        action: () => mutateLogout(contactId.toString()),
        class: styles.logOutBtn,
    };
    const logIn = {
        label: t('common.register'),
        action: () => navigate('/login'),
        class: styles.logInBtn,
    };

    const btn = isAuthenticated ? logOut : logIn;

    return (
        <Preloader isLoading={isLoading} error={null}>
            <header className={styles.header}>
                <div className={styles['inner-container']}>
                    {isAuthenticated ? (
                        <>
                            <input type="checkbox" id="isMenuOpened" className={`${styles['is-menu-opened']} hidden`} hidden />
                            <label htmlFor="isMenuOpened" />
                        </>
                    ) : ''}

                    <DekaLogo />
                    <nav className={styles['nav-links']} onClick={() => document.getElementById('isMenuOpened')?.click()}>
                        {activeNavigation.map((item) => (
                            <NavLink
                                to={item.link}
                                key={item.label}
                                className={({ isActive }) => (isActive ? styles.active : '')}
                                end
                            >
                                {t(item.label)}
                            </NavLink>
                        ))}
                    </nav>
                    <Button
                        onClick={btn?.action}
                        className={btn.class}
                        size="small"
                    >
                        {btn?.label}
                    </Button>
                    <div className={styles.backdrop} />
                </div>
            </header>
        </Preloader>
    );
};
